import { createContext, useContext } from "react";
import { ISelectedFilterMap } from "./types";

const initialState: ISelectedFilterMap = { featured: {}, secondary: {} };
const SelectedFiltersContext = createContext<ISelectedFilterMap>(initialState);

const useSelectedFilters = () => useContext(SelectedFiltersContext);

export { SelectedFiltersContext, useSelectedFilters };
